import { useTranslation } from 'react-i18next'

import { LinkButton } from '~/components/link-button'

export const EmailConfirmation = () => {
  const { t } = useTranslation()

  return (
    <div className="flex w-full max-w-md flex-col gap-4">
      <h3 className="text-center text-lg">{t('Almost there Please check your email to confirm your registration')}</h3>
      <LinkButton to="/auth/login" variant="outline">
        {t('To login')}
      </LinkButton>
    </div>
  )
}
